export default function About() {
  return (
    <>
      {/* ABOUT */}
      <section id="about" className="relative py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="mono text-[11px] uppercase tracking-[0.24em] text-cyan-300">
            01 · About the Forum
          </div>
          <h2 className="font-display mt-4 text-3xl lg:text-4xl font-bold text-white max-w-3xl">
            About the Philippines National Cyber Resilience Forum.
          </h2>

          <div className="mt-12 grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
            {/* Text */}
            <div className="lg:col-span-7 space-y-5 text-slate-300 text-base lg:text-lg leading-relaxed">
              <p>
                The Philippines National Cyber Resilience Forum is the
                country&apos;s premier government-military cybersecurity platform
                — a high-level, action-oriented gathering convened in observance
                of National Cybersecurity Awareness Month to strengthen the
                nation&apos;s collective defense against evolving digital
                threats.
              </p>
              <p>
                Organized by Convergence Experts PLT, the Forum unites senior
                government officials, Armed Forces of the Philippines leadership,
                the Philippine National Police Anti-Cybercrime Group, and
                strategic industry partners in a focused dialogue on national
                cyber resilience. It is a platform built not just for awareness,
                but for alignment — where policy, strategy, and operational
                expertise converge to produce real commitments and lasting
                partnerships.
              </p>
              <p>
                In an era where the battlefield extends into cyberspace, the
                Philippines National Cyber Resilience Forum stands as the
                nation&apos;s definitive answer: collaborative, prepared, and
                resolute.
              </p>

              <div className="pt-4">
                <div className="inline-flex items-center gap-3 mono text-[12px] uppercase tracking-[0.24em] text-cyan-300 border-l-2 border-cyan-400 pl-4">
                  Collaborate.&nbsp; Innovate.&nbsp; Defend.
                </div>
              </div>
            </div>

            {/* IC chip image */}
            <div className="lg:col-span-5">
              <div className="relative rounded-xl overflow-hidden border border-cyan-900/60 bg-black shadow-[0_0_60px_-15px_rgba(0,240,255,0.35)]">
                <img
                  src="/img/ic_chip.jpg"
                  alt="Secure IC chip — cyber defense at the silicon layer"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                  decoding="async"
                  data-testid="about-ic-chip-image"
                />
                <div className="pointer-events-none absolute -top-px left-6 right-6 h-px bg-gradient-to-r from-transparent via-cyan-400/70 to-transparent" />
                <div className="pointer-events-none absolute -bottom-px left-6 right-6 h-px bg-gradient-to-r from-transparent via-cyan-400/70 to-transparent" />
              </div>
              <div className="mt-4 flex items-center justify-between">
                <div className="mono text-[10px] uppercase tracking-[0.24em] text-cyan-300/80">
                  Defense at the silicon layer
                </div>
                <div className="mono text-[10px] uppercase tracking-[0.24em] text-slate-500">
                  From Brochure
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHY PHILIPPINES */}
      <section
        id="why-philippines"
        className="relative border-t border-cyan-900/30 bg-[#050d1a]"
      >
        {/* Manila skyline banner */}
        <div className="relative w-full">
          <img
            src="/img/manila_skyline.jpg"
            alt="Manila skyline at dusk"
            className="w-full h-[280px] sm:h-[360px] lg:h-[440px] object-cover"
            loading="lazy"
            decoding="async"
            data-testid="why-manila-skyline-image"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#050d1a]/40 to-[#050d1a]" />
          <div className="absolute inset-x-0 bottom-6 px-6 lg:px-10">
            <div className="max-w-7xl mx-auto">
              <div className="mono text-[11px] uppercase tracking-[0.24em] text-cyan-300 drop-shadow-[0_2px_10px_rgba(0,0,0,0.7)]">
                02 · Why Philippines
              </div>
              <h2 className="font-display mt-2 text-3xl lg:text-4xl font-bold text-white max-w-3xl drop-shadow-[0_2px_16px_rgba(0,0,0,0.7)]">
                A digital economy at the inflection point.
              </h2>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
          <ul className="grid lg:grid-cols-2 gap-6">
            {[
              "The Philippines is one of the fastest-growing cybersecurity markets in Asia, driven by a sharp rise in cyber incidents, accelerating digital transformation, and strong government commitment to national cyber resilience.",
              "The Department of Information and Communications Technology (DICT) has significantly increased cybersecurity funding, while the National Cybersecurity Plan 2023–2028 is creating new procurement and partnership opportunities across government, critical infrastructure, and enterprise sectors.",
              "With sustained investment from both public and private stakeholders, the Philippines is quickly becoming a strategic hub for cybersecurity innovation, capacity-building, and technology adoption in the region.",
              "Hosting the event in the Philippines positions attendees at the forefront of this growth, offering direct access to decision-makers, emerging market opportunities, and insights into the country’s evolving digital security landscape.",
            ].map((text, i) => (
              <li
                key={text.slice(0, 40)}
                className="rounded-lg border border-cyan-900/50 bg-[#0B1120] p-6 hover:border-cyan-400/60 transition-colors"
              >
                <div className="mono text-[11px] uppercase tracking-widest text-cyan-300 mb-3">
                  0{i + 1}
                </div>
                <p className="text-slate-300 leading-relaxed">{text}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}
